import React from 'react';

const WaveEffect = () => {
  const styles = {
    effectContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      background: 'linear-gradient(180deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
    },
    waveLayer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '200%',
      height: '100%',
      animation: 'wave 20s linear infinite',
    },
    wave1: {
      position: 'absolute',
      bottom: '0',
      left: 0,
      width: '200%',
      height: '100%',
      background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 1200 120\' preserveAspectRatio=\'none\'%3E%3Cpath d=\'M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z\' fill=\'%231e3a8a\' fill-opacity=\'0.3\'/%3E%3C/svg%3E") repeat-x',
      backgroundSize: '50% 100%',
      animation: 'wave 15s linear infinite',
      opacity: 0.5,
    },
    wave2: {
      position: 'absolute',
      bottom: '0',
      left: 0,
      width: '200%',
      height: '100%',
      background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 1200 120\' preserveAspectRatio=\'none\'%3E%3Cpath d=\'M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z\' fill=\'%232563eb\' fill-opacity=\'0.4\'/%3E%3C/svg%3E") repeat-x',
      backgroundSize: '50% 100%',
      animation: 'wave 20s linear infinite reverse',
      opacity: 0.6,
    },
    wave3: {
      position: 'absolute',
      bottom: '0',
      left: 0,
      width: '200%',
      height: '100%',
      background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 1200 120\' preserveAspectRatio=\'none\'%3E%3Cpath d=\'M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z\' fill=\'%233b82f6\' fill-opacity=\'0.5\'/%3E%3C/svg%3E") repeat-x',
      backgroundSize: '50% 100%',
      animation: 'wave 25s linear infinite',
      opacity: 0.7,
    },
    circlePattern: {
      position: 'absolute',
      top: '10%',
      right: '10%',
      width: '400px',
      height: '400px',
      borderRadius: '50%',
      border: '2px solid rgba(255, 255, 255, 0.1)',
      animation: 'float 6s ease-in-out infinite',
    },
    circlePattern2: {
      position: 'absolute',
      bottom: '15%',
      left: '15%',
      width: '300px',
      height: '300px',
      borderRadius: '50%',
      border: '2px solid rgba(255, 255, 255, 0.08)',
      animation: 'float 8s ease-in-out infinite reverse',
    },
  };

  return (
    <div style={styles.effectContainer}>
      <style>
        {`
          @keyframes wave {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0) scale(1);
            }
            50% {
              transform: translateY(-20px) scale(1.05);
            }
          }
        `}
      </style>

      {/* 波のレイヤー */}
      <div style={styles.wave1}></div>
      <div style={styles.wave2}></div>
      <div style={styles.wave3}></div>

      {/* 装飾的な円 */}
      <div style={styles.circlePattern}></div>
      <div style={styles.circlePattern2}></div>
    </div>
  );
};

export default WaveEffect;